import apiClient from "./axios.config";

const consultService = {
  submitConsultForm(payload) {
    return apiClient.post("/website/consultation", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default consultService;
